import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { shellRoute } from './index'
import { tasksSearchSchema } from '../search'

export const tasksRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/tasks',
  validateSearch: tasksSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/tasks'), 'TasksPage'),
})
